var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-base-back"},[_c('div',{staticClass:"modal-base-dialog"},[_c('div',{staticClass:"modal-inner"},[_c('img',{class:("loading-pic" + _vm.speed),attrs:{"src":"/loading.png"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }